import React from "react";
import styles from "./index.module.less";

class Operate extends React.Component {
  render() {
    return <div className={styles.operateWrap}>{this.props.children}</div>;
  }
}

export default Operate;
